module.exports = __webpack_public_path__ + "img/登录电脑客户端.d0a6a36e.png";